import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Title } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SCornerstoneHero = styled.section`
  display: grid;
  grid-gap: ${pxToRem(36)}rem;
  grid-template-columns: repeat(2, 1fr);

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
`

export const SImage = styled.div`
  width: 100%;
`

export const SMediaArea = styled.div`
  grid-area: media;
`

export const SLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  @media ${BREAKPOINTS.MD.max} {
    align-items: center;
  }
`

export const STitle = styled(Title)`
  margin-bottom: 1.5rem;
  text-align: left;

  white-space: pre-line;

  @media ${BREAKPOINTS.MD.min} {
    max-width: ${pxToRem(561)}rem;
  }
  @media ${BREAKPOINTS.MD.max} {
    text-align: center;
    margin-bottom: 0.5rem;
  }
`

export const SDetails = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  line-height: ${pxToRem(28)}rem;

  & button {
    width: min-content;
  }

  @media ${BREAKPOINTS.MD.min} {
    max-width: ${pxToRem(488)}rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 0;
  }
`

export const SButton = styled(Button)`
  margin-bottom: 1.5rem;
  width: fit-content;
  align-self: unset;
`
